// extracted by mini-css-extract-plugin
module.exports = {"container":"CardSlider_container__xeUUN","content":"CardSlider_content__giPY5"};